"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const opexs_1 = require("@/store/ducks/opexs");
const opexs_2 = require("@/services/opexs");
const listOpexsUseCase_1 = __importDefault(require("./listOpexsUseCase"));
function updateOpexUseCase(opexId, payload) {
    console.log(opexId);
    return (dispatch) => {
        dispatch((0, opexs_1.startUpdateOpexReducer)());
        return (0, opexs_2.updateOpexService)(opexId, payload)
            .then(async () => {
            dispatch((0, opexs_1.updateOpexSuccessReducer)());
            await (0, listOpexsUseCase_1.default)()(dispatch);
            dispatch((0, opexs_1.openOpexToastReducer)({
                status: "success",
                message: "Opex updated successfully",
            }));
        })
            .catch(() => {
            dispatch((0, opexs_1.updateOpexErrorReducer)());
            dispatch((0, opexs_1.openOpexToastReducer)({
                status: "error",
                message: "Error updating Opex.",
            }));
        });
    };
}
exports.default = updateOpexUseCase;
